import { cvAssignmentToolGroupItem, GroupDTO, LoginApiModel } from "src/app/reusables/assign-tool/angular-assign-tool/angular-assign-tool.models";

export interface SelectedTeam {
    name: string;
    data: GroupDTO;
    permission: DashboardAccessPermissions;
}

export interface SelectedEmployee {
    name: string;
    data: LoginApiModel;
    permission: DashboardAccessPermissions;
}

export enum DashboardAccessPermissions {
    None = 'None',
    Read = 'Read',
    Write = 'Write',
    ReadTheirs = 'ReadTheirs',
    WriteTheirs = 'WriteTheirs'
}

export enum SelectionType {
    AllEmployees = 'AllEmployees',
    Custom = 'Custom',
    None = 'None'
}

export class AccessGroup {
    public group: any;
    public profiles: Map<number, AccessProfile> = new Map();
    public permission: DashboardAccessPermissions;
}

export class AccessProfile {
    public profile: any;
    public permission: DashboardAccessPermissions;
}

export class AccessLogin {
    public login: any;
    public permission: DashboardAccessPermissions;
}

export class AccessChangesDTO {
    public isLogin: boolean;
    public permission: DashboardAccessPermissions;
    public id: number;
    public companyID?: number;
    public groupID?: number;
    public groupLevel?: number;
    public baseGroupType?: number;
}

export class AccessChanges {
    public groups: Map<number, AccessGroup> = new Map<number, AccessGroup>();
    public logins: Map<number, AccessLogin> = new Map<number, AccessLogin>();
}

// match data coming in from loadRoles()
export class ProfileData {
    public CompanyID: number;
    public GroupID: number;
    public GroupLevel: number;
    public GroupType: any;
    public GroupTypeStr: string;
    public ProfileID: number;
    public ProfileName: string;
}
